import { render, staticRenderFns } from "./USBusiness.vue?vue&type=template&id=96dcc230&scoped=true&"
import script from "./USBusiness.vue?vue&type=script&lang=js&"
export * from "./USBusiness.vue?vue&type=script&lang=js&"
import style0 from "./USBusiness.vue?vue&type=style&index=0&id=96dcc230&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96dcc230",
  null
  
)

export default component.exports